export default __webpack_public_path__ + "static/media/logo.1c121c8c.png";